module.exports = __webpack_public_path__ + "static/vegan-cola_sketch-b6c490820eeaf4c789a369bb45bebf1f.jpg";